import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const FAQS = [{
  q: '¿Cómo recibiré el Sistema OFM?',
  a: 'Inmediatamente después del pago recibirás un correo con acceso a todos los tomos y bonos en formato digital. Podrás descargarlos y consultarlos siempre que lo necesites.'
}, {
  q: '¿Necesito ser ortodoncista?',
  a: 'No. El sistema fue diseñado para odontólogos generales y odontopediatras que desean tomar decisiones clínicas con mayor seguridad en tratamientos interceptivos.'
}, {
  q: '¿Sirve si ya tengo experiencia en OFM?',
  a: 'Sí. No reemplaza tu experiencia: la organiza. Muchos profesionales experimentados utilizan el sistema para estructurar mejor su razonamiento clínico y reducir la variabilidad en sus decisiones.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí. Pagas una sola vez y el acceso es permanente.'
}, {
  q: '¿En qué moneda pago?',
  a: 'El cambio de moneda es automático. Verás el precio convertido a la moneda de tu país en el checkout, sin que tengas que hacer ningún cálculo ni trámite adicional.'
}, {
  q: '¿Puedo consultarlo desde el celular?',
  a: 'Sí. Todo el contenido está disponible en formato PDF para que puedas revisarlo desde computadora, tablet o teléfono cuando lo necesites.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-79" data-mp="16np9nfajv4bv">
      <div className="mx-auto w-full max-w-2xl" data-id="element-80" data-mp="16ps6oja4dxq3">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-81" data-mp="s044zgy10x1u">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-82" data-mp="iycy48rr2k6e">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-ofm-100 bg-white" data-id="element-83" data-mp="mywxlizspzvp" data-mpi={i}>
                <h3 data-id="element-84" data-mp="2poge7jmkmubu">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 p-4 text-left" data-id="element-85" data-mp="2kw6mpz5t5m7g">
                    <span className="text-[14px] font-bold leading-snug text-ofm-900 sm:text-[15px]" data-id="element-86" data-mp="38lhit3c7qsf9">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ofm-600 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-87" data-mp="33mxvayhz18ks" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-88" data-mp="1n620y96hlcdu">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-89" data-mp="1j59prae20xex">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-ofm-900/70" data-id="element-90" data-mp="7nw10edaav62">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <CTAButton className="mt-9" label="🦷 RESUELVE MIS DUDAS: LO QUIERO" subline="Pago único de $12.99 USD · Garantía de 7 días" data-id="element-91" data-mp="mcjrw7c6qgpo" />
      </div>
    </section>;
}